import axios from 'axios';

// Base URL for API - change this if your backend is on a different port/host
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('xalent_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API Service Methods
export const videoService = {
  // Generate a new video
  generateVideo: async (prompt, dimension = '1280*720', duration = 30) => {
    const payload = {
      prompt,
      duration,
      model: 'wan',
      dimension,
    };
    
    const response = await api.post('/generate', payload);
    return response.data;
  },

  // Get status of a video generation job
  getJobStatus: async (jobId) => {
    const response = await api.get(`/status/${jobId}`);
    return response.data;
  },

  // Download video
  downloadVideo: (jobId) => {
    return `${API_BASE_URL}/download/${jobId}`;
  },

  // Get video URL for preview/streaming (use public URL from job data)
  getVideoUrl: (job) => {
    // If job has public_video_url, use that, otherwise fallback to job_id based URL
    if (typeof job === 'object' && job.public_video_url) {
      return `${API_BASE_URL}${job.public_video_url}`;
    }
    // Fallback for job_id string
    const jobId = typeof job === 'string' ? job : job.jobId;
    return `${API_BASE_URL}/public/videos/${jobId}.mp4`;
  },

  // Get all jobs
  getAllJobs: async () => {
    const response = await api.get('/jobs');
    return response.data;
  },

  // Delete a job
  deleteJob: async (jobId) => {
    const response = await api.delete(`/jobs/${jobId}`);
    return response.data;
  },

  // Get available dimensions
  getDimensions: async () => {
    const response = await api.get('/dimensions');
    return response.data;
  },

  // Get API info
  getApiInfo: async () => {
    const response = await api.get('/api/info');
    return response.data;
  },
};

export default api;
